import * as Storage from "../lib/Storage.ts";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";
import $ from "../$.js";
import { toLocaleString } from "../lib/DateUtils.ts";
import { Calendar } from "../lib/fullcalendar/all.ts";

var currentFullCalendar:Calendar;

Html.register({
  timetabletoday:function() {
    currentFullCalendar.today();
  },
  timetablenext:function() {
    currentFullCalendar.next();
  },
  timetableprev:function() {
    currentFullCalendar.prev();
  },
  timetableview:function(value){
    Storage.localSet('settings.timetableView',value);
    currentFullCalendar.changeView(value)
  }
});
/**
 * @param currenttimetable the TimetableBean
 * @param info the info from fullCalendar
 */
export function updateViewSelector(currenttimetable, info){
  ['timeGridDay','timeGridWeek','dayGridMonth','listYear'].forEach(viewType=>{
    $(`[data-fw-onclick="timetableview|${viewType}"]`)
      .toggleClass('selected',viewType===info.view.type)
  })
  if(currenttimetable.isOneTime){
    $('[data-fw-onclick="timetableprev"]').show()
    $('[data-fw-onclick="timetablenext"]').show()
    
    $('.timenav-main').text(info.view.title);
    $('.timenav').show();
      
    return;
  }
  var weeks = currenttimetable.weeks;
  if(info.view.type==="timeGridWeek"){
    if(currenttimetable.recurrencyDescriptor.recurrencyInterval===1){
      $('.timenav').hide();
      return;
    }else{
      $('.timenav').show();
      for(var weekIdx=weeks.length-1;weekIdx>=0;weekIdx--){
        let week = weeks[weekIdx];
        if(info.view.currentStart.getTime()>=week.start.getTime()){
          currenttimetable.currentWeekIndex = weekIdx;
          $('.timenav-main').text(week.name+(week.isCurrent?' - '+i18n.get('timetable.current'):''));
          break;
        }
      }
      $('[data-fw-onclick="timetableprev"]').toggle(weekIdx > 0);
      $('[data-fw-onclick="timetablenext"]').toggle(weekIdx < weeks.length-1);
    }
  }else if(info.view.type==="timeGridDay"){
    $('.timenav').show();
    for(var weekIdx=weeks.length-1;weekIdx>=0;weekIdx--){
      let week = weeks[weekIdx];
      if(info.view.currentStart.getTime()>=week.start.getTime()){
        currenttimetable.currentWeekIndex = weekIdx;
        var displayWeek = weeks.length>1?week.name+' - ':'';
        $('.timenav-main').text(displayWeek+toLocaleString(info.view.currentStart,{weekday:'long'}));
        break;
      }
    }
    $('[data-fw-onclick="timetableprev"]').toggle(info.view.currentStart.getTime()>weeks[0].start.getTime());
    $('[data-fw-onclick="timetablenext"]').toggle(info.view.currentEnd.getTime()<weeks[weeks.length-1].end.getTime());
  }
      
}



export function set(calendar :Calendar,timetable){
  currentFullCalendar = calendar;
}
function getAllowedView(timetable){
  var allowedView;
  if(timetable.isOneTime){
    allowedView = ['timeGridDay','timeGridWeek'/*,'dayGridMonth','listYear'*/]
  }else{
    allowedView = ['timeGridDay','timeGridWeek']
  }
  ['timeGridDay','timeGridWeek','dayGridMonth','listYear'].forEach(viewType=>{
    $(`[data-fw-onclick="timetableview|${viewType}"]`)
      .toggle(allowedView.indexOf(viewType)>-1)
  })
  return allowedView;
}
export function getView(timetable){
  const 
    storedView = Storage.localGet('settings.timetableView');
  if(getAllowedView(timetable).indexOf(storedView)===-1){
    return 'timeGridWeek'
  }  
  return storedView;
}
export function get():Calendar{
  return currentFullCalendar;
}